import React, {useEffect, useState} from 'react'
import ImageMap from 'virtual_congress/components/image_map'
import EventBooth from './event_booth'
import {} from '../reducer.jsx'
import {useSelector} from 'react-redux'
import {
  Switch,
  Route,
} from "react-router-dom";
import {VelocityTransitionGroup} from 'velocity-react';
import AddonRenderer from "./addon_renderer";
import VideoRoom from "../components/video_room";
import PushNotification from "../../../../shared/virtual_congress/booth_editor/components/push_notification";
import GoogleAnalyticsTracking from "../../../../shared/virtual_congress/effects/google_analytics_tracking";
import HotspotTracking from "../../../../shared/virtual_congress/effects/clicked_hotspots_tracker";
//import MarzipanoContainer from "../components/marzipano/marzipano_container";
require('velocity-animate');
require('velocity-animate/velocity.ui');

const Transition = (props) => {
  return (
    <VelocityTransitionGroup component="div" enter={{animation: "fadeIn"}} leave={{delay: 50, animation: "fadeOut"}}>
      <div key={props.id}>
        {props.children}
      </div>
    </VelocityTransitionGroup>
  )
}

//
// const TEST = ({map, preselectedHotspotIdentifier}) => {
//   const imageMapConfigs = useSelector((state) => state.imageMapConfigs)
//   const imageHotspots = useSelector((state) => state.imageHotspots)
//   const imageHotspotConfigs = useSelector((state) => state.imageHotspotConfigs)
//   let preselectedHotspot = null
//
//   if (map == null)
//     return <div className="alert alert-danger">No Map with this ID found</div>
//
//   let mapConfig = imageMapConfigs.find((imc) => imc.id == map.image_map_config_id)
//
//   if (preselectedHotspotIdentifier) {
//     const preselectedImageHotspotConfig = imageHotspotConfigs.find((ihc) => ihc.identifier == preselectedHotspotIdentifier)
//     preselectedHotspot = imageHotspots.find((ih) => ih.image_hotspot_config_id == preselectedImageHotspotConfig?.id && ih.image_map_id == map.id)
//     if (preselectedHotspot) {
//       // preselectedHotspot = {...preselectedHotspot}
//     }
//   }
//
//   switch (mapConfig.identifier) {
//     case "event_booth":
//       return <>
//         <Transition id={map.id}>
//           <EventBooth imageMap={map}/>
//           <AddonRenderer imageMap={map}/>
//         </Transition>
//       </>;
//     default:
//       return <>
//         <Transition id={map.id}>
//           <ImageMap por preselectedHotspot={preselectedHotspot} imageMap={map}/>
//           <AddonRenderer preselectedHotspot={preselectedHotspot} clearPreselectedHotspot={() => setPreselectedHotspot(null)} imageMap={map}/>
//         </Transition>
//       </>;
//   }
// }

export default function App(props) {
  const imageMaps = useSelector((state) => state.imageMaps)
  const imageMapConfigs = useSelector((state) => state.imageMapConfigs)
  const imageHotspots = useSelector((state) => state.imageHotspots)
  const imageHotspotConfigs = useSelector((state) => state.imageHotspotConfigs)
  const tagOwner = useSelector(state => state.tagOwner)



  const getMap = (map, preselectedHotspotIdentifier) => {
    if (map == null)
      return <div className="alert alert-danger">No Map with this ID found</div>

    let mapConfig = imageMapConfigs.find((imc) => imc.id == map.image_map_config_id)
    let preselectedHotspot = null

    console.log({preselectedHotspotIdentifier})
    if (preselectedHotspotIdentifier) {
      const preselectedImageHotspotConfig = imageHotspotConfigs.find((ihc) => ihc.identifier == preselectedHotspotIdentifier)
      preselectedHotspot = imageHotspots.find((ih) => ih.image_hotspot_config_id == preselectedImageHotspotConfig?.id && ih.image_map_id == map.id)
      if (preselectedHotspot) {
        // preselectedHotspot = {...preselectedHotspot} // Duplicates the object so the use effect in the image map is triggered
      }
    }

    switch (mapConfig.identifier) {
      case "event_booth":
        return <>
          <Transition id={map.id}>
            <EventBooth imageMap={map}/>
            <AddonRenderer imageMap={map}/>
          </Transition>
        </>;
      default:
        return <>
          <Transition id={map.id}>
            <ImageMap preselectedHotspot={preselectedHotspot} imageMap={map}/>
            <AddonRenderer preselectedHotspot={preselectedHotspot} imageMap={map}/>
          </Transition>
        </>;
    }
  }

  return (
    <React.Fragment>
      <PushNotification/>
      <VelocityTransitionGroup component="div" enter={{animation: "fadeIn", delay: 500}} leave={{animation: "fadeOut"}}>
        <Switch>
          <Route path="/stream/:videoRoomId" render={({match}) => { return <VideoRoom key={"videoroom" + match.params.videoRoomId} videoRoomId={match.params.videoRoomId}/> }}/>

          <Route path="/stream">
            <VideoRoom key="videoroom"/>
          </Route>
          {/*
          <Route path="/marzipano" render={() => {
            return <MarzipanoContainer/>
          }}/>*/}

          <Route path="/" exact render={({match}) => getMap(imageMaps.find((img) => img.identifier == (tagOwner.external_id != "public_tag_owner" ? "entrance_lobby" : "entrance_lobby_public")))}/>

          <Route path="/imgi/:identifier/hs/:hotspotConfigIdentifier" exact render={({match}) => {
            // return <TEST key={Math.random()} map={imageMaps.find((img) => img.identifier == match.params.identifier)} preselectedHotspotIdentifier={match.params.hotspotConfigIdentifier}></TEST>
            // return getMap(imageMaps.find((img) => img.identifier == match.params.identifier))
            return getMap(imageMaps.find((img) => img.identifier == match.params.identifier), match.params.hotspotConfigIdentifier)
          }}/>
          <Route path="/imgi/:identifier" exact
                 render={({match}) => getMap(imageMaps.find((img) => img.identifier == match.params.identifier))}/>
          <Route path="/image_map/:id"
                 render={({match}) => getMap(imageMaps.find((img) => img.id == match.params.id))}/>
        </Switch>
      </VelocityTransitionGroup>
      <HotspotTracking/>
      {/*<Navigation/>*/}
      <GoogleAnalyticsTracking trackingId={""}/>
    </React.Fragment>
  )
}